    let wishlistEvents = new CustomEvent('change_wishlist')
    
    const video = document.getElementById('videoElement');
    const playButton = document.getElementById('playButton');
    const playIcon = document.getElementById('playIcon');

    if(Boolean(playButton)){

    // Function to handle play/pause toggle
    function togglePlayPause() {
        if (video.paused) {
            video.play();
            playIcon.style.display = 'none'; // Hide the play icon when playing
        } else {
            video.pause();
            playIcon.style.display = 'flex'; // Show the play icon when paused
        }
    }

    // Initial setup
    playButton.addEventListener('click', togglePlayPause);
   

    // Show play icon when video is paused
    video.addEventListener('pause', function() {
        playIcon.style.display = 'flex'; // Show the play icon when paused
    });

    // Hide play icon when video is playing
    video.addEventListener('play', function() {
        playIcon.style.display = 'none'; // Hide the play icon when playing
    });
    }

let player;
    var playButtonY = document.getElementById('playButtonY');
    var playIconY = document.getElementById('playIconY');
     var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    // This function must be globally accessible for the YouTube IFrame API to call it
   function onYouTubePlayerAPIReady()  {
        player = new YT.Player('ytplayer', {
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            },
          videoId: 'QHgNoSYlhYs',
          height: 'auto',
          width: '100%'
        });
    };

    function onPlayerReady(event) {
      
        playButtonY.addEventListener('click', function() {
            if (player.getPlayerState() === YT.PlayerState.PAUSED || player.getPlayerState() === YT.PlayerState.ENDED||player.getPlayerState()===5) {
                player.playVideo();
            } else {
                player.pauseVideo();
            }
        });
    }

    function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.PLAYING) {
            playIconY.style.display = 'none'; // Hide play icon
        } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
            playIconY.style.display = 'flex'; // Show play icon
        }
    }

var getCustomerId = function() {
    try {
      let curr = window.ShopifyAnalytics.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch(e) { }
    try {
      let curr = window.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }    
    try {
      let curr = _st.cid;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }
    try {
      let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
      if (curr !== undefined && curr !== null && curr !== "") {
        return curr;
      }
    } catch (e) { }
    return null;
  }



async function getCities(country){
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const raw = JSON.stringify({
  "country": country
  });
  
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  };

  return fetch("https://countriesnow.space/api/v0.1/countries/cities", requestOptions)
  .then((response) => response.json())
  .then((result) => result.data)
  .catch((error) => console.error(error));
}

async function CreateNewVariant(variant_id, quantity_length){
  let formData = {
    'shop': window.miracheltessutiapp.shop,
    'customer':{
      'id': window.miracheltessutiapp.customer.id()
    } ,
   'items': [{
    'id': variant_id,
    'properties': {
      'length': quantity_length
    }
    }]
  };
  
  return fetch(window.miracheltessutiapp.routes.root + 'api/new-variant', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .catch((error) => {
    console.error('Error:', error);
  });
}

async function AddToCart(variant_id, quantity, quantity_length, properties = {}, update_up_cart = 'true'){

  if(Boolean(quantity_length)){
    return CreateNewVariant(variant_id, quantity_length).then((data)=>{
      let items = [];
      data['variants'].forEach((variant)=>{

        properties['_length'] = quantity_length;
        
        items.push({
          'id': Number(variant.replace("gid://shopify/ProductVariant/", '')),
          'quantity': quantity,
          'properties': properties,
        });
      })
      
      let formData = {
       'items': items
      };
      
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData) //date
      })
      .then(response =>response.json())
        .then((data)=>{
          if(update_up_cart == 'true'){
            getShopCart().then((new_cart)=>{
              setTimeout(()=>{
                UpdateAppCart(new_cart).then(()=>{
                  document.dispatchEvent(new CustomEvent("AddToCart", { detail: {cart: new_cart}  } ));
                  //document.dispatchEvent(new CustomEvent("UpdateCart", { detail: {cart: new_cart}  } ));
                })
              }, 100) 
            })
          }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    })
  }else{
    let formData = {
       'items': [
         { 'id': variant_id, 'quantity': quantity, 'properties': properties }
       ]
      };
      
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response =>response.json())
        .then((data)=>{
          console.log(data);
          
          getShopCart().then((new_cart)=>{
            setTimeout(()=>{
              UpdateAppCart(new_cart).then(()=>{
                document.dispatchEvent(new CustomEvent("AddToCart", { detail: {cart: new_cart}  } ));
                //document.dispatchEvent(new CustomEvent("UpdateCart", { detail: {cart: new_cart}  } ));
              })
            }, 100)
          })
        
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

async function AppdateCart(updates){

  return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({updates})
    })
    .then(response => response.json())
    .then((data)=>{
      getShopCart().then((new_cart)=>{
        UpdateAppCart(new_cart).then(()=>{
          //document.dispatchEvent(new CustomEvent("AddToCart", { detail: {cart: new_cart}  } ));
          document.dispatchEvent(new CustomEvent("UpdateCart", { detail: {cart: new_cart}  } ));
        });
        
      })
    })
    .catch((error) => {
      console.error('Error:', error);
  });

}

async function UpdateAppCart(cart){
   
    let formData = {
    'shop': window.miracheltessutiapp.shop,
    'cart': cart
    };
    
    return fetch(window.miracheltessutiapp.routes.root + 'api/update-cart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });
  
  
  
}

function searchInit() {
  let main = document.querySelector('main')
  let searchBtn = document.querySelector('[search-button]')
  let icon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>'
  let code = `<form method="get" action="/search" form-search><div class="searchBlock">${icon}<input type="text" placeholder="Search..." name="q"></div></form>`

  searchBtn.addEventListener('click', e => {
    if(document.body.contains(document.querySelector('.searchBlock'))) {
      return true
    }
    main.insertAdjacentHTML('afterbegin', code)
    setTimeout(() => {
      document.querySelector('.searchBlock').classList.add('active')
    }, 100)
  })

  document.addEventListener('click', e => {
    let searchBlock = document.querySelector('.searchBlock');
    if (searchBlock && !searchBlock.contains(e.target) && !searchBtn.contains(e.target)) {
      searchBlock.classList.remove('active');
      setTimeout(() => {
        let formSearch = document.querySelector('[form-search]');
        if (formSearch) {
          formSearch.remove();
        }
      }, 300); 
    }
  });
} searchInit()

function eventEmit(le, name, obj) {
  le = new CustomEvent(name, {detail: obj})
  document.dispatchEvent(le)
  return le //Refactor
}

function Wishlist(object) {
  let favorites = JSON.parse(localStorage.getItem('favorites')) || [];
  let current_index = favorites.findIndex(id => id === object.product_id);
  let toggle_wishlist = object.toggle_wishlist;

  if (current_index === -1) {
    toggle_wishlist.classList.remove('active');
  } else {
    toggle_wishlist.classList.add('active');
  }

  return {
    add: function (id) {
      if (favorites.findIndex(fav => fav === id) !== -1) return;
      favorites.push(id);
      this._updateStorage();
      this._update();
      eventEmit(wishlistEvents, 'change_wishlist', {
        type: 'add',
        count: this.getCount(),
        product_id: Number(object.product_id)
      });
    },

    remove: function () {
      if (current_index >= 0) {
        favorites.splice(current_index, 1);
        this._updateStorage();
        this._update();
        eventEmit(wishlistEvents, 'change_wishlist', {
          type: 'remove',
          count: this.getCount(),
          product_id: Number(object.product_id)
        });
      }
    },

    getIndex: function () {
      this._update();
      return current_index;
    },

    getCount: function () {
      return favorites.length;
    },

    _update: function () {
      favorites = JSON.parse(localStorage.getItem('favorites')) || [];
      current_index = favorites.findIndex(id => id === object.product_id);
      toggle_wishlist = object.toggle_wishlist;
    },

    _updateStorage: function () {
      localStorage.setItem('favorites', JSON.stringify(favorites));
    }
  };
}

function MenuInit() {
  const BurgerButton = document.querySelector('[open-menu-items]')
  const MenuClose = document.querySelector('[menu-items-close]')
  const Menu = document.querySelector('[data-menu-items]')

  BurgerButton.addEventListener('click', (e) => {
    Menu.dataset.menuItems = 1
  })

  MenuClose.addEventListener('click', () => {
    Menu.dataset.menuItems = 0
  })
}

function ProductPopup(type, variables){

  if(Boolean(type)){

  const popup = document.createElement('div');
  popup.classList.add('Popup');
  
  const Templates = {
    'getShareInfo': {
      icon: `<svg width="64" height="76" viewBox="0 0 64 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="61" height="73" rx="13.5" stroke="black" stroke-width="3"/>
    <path d="M26.28 10H37.08L35.08 49.04H28.28L26.28 10ZM26.04 62.08C26.04 60.5333 26.5733 59.2533 27.64 58.24C28.76 57.2267 30.12 56.72 31.72 56.72C33.32 56.72 34.6533 57.2267 35.72 58.24C36.7867 59.2533 37.32 60.5333 37.32 62.08C37.32 63.6267 36.7867 64.9333 35.72 66C34.6533 67.0133 33.32 67.52 31.72 67.52C30.12 67.52 28.76 67.0133 27.64 66C26.5733 64.9333 26.04 63.6267 26.04 62.08Z" fill="black"/>
    </svg>`,
      title: 'Получите образец',
      description: '<p>При оформлении заказа на сумму 300 ₪ вы получаете возможность заказать 6 образцов ткани для оценки качества и выбора наилучшего варианта. Если же вы хотите заказать образцы без оформления покупки, вы можете приобрести неограниченное количество образцов за отдельную оплату.</p>'
    },
    'reservInfo': {
      icon: `<img src="https://cdn.shopify.com/s/files/1/0607/6370/1326/files/reserv.png?v=1718948482" width="69px" height="76px" alt="close-modal">`,
      title: variables.title,
      description: `<p> ${variables.description} </p>`,
      button:{
        label: variables.button,
        link: ()=>{popup.remove()}
      }
    },
  }

  if(Templates[type]){
    
  const back_overflow = document.createElement('div');
  back_overflow.classList.add('PopupBackOverflou');

  back_overflow.addEventListener('click', ()=>{
    popup.remove();
  })

  popup.append(back_overflow);

  const popup_content = document.createElement('div');
  popup_content.classList.add('PopupContent');

  const popup_content_btn_close = document.createElement('button');
  popup_content_btn_close.classList.add('PopupContentButtonClose');
  popup_content_btn_close.innerHTML = `<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729"/>
</svg>`;
  popup_content_btn_close.addEventListener('click', ()=>{
    popup.remove();
  })

  popup_content.append(popup_content_btn_close);

    console.log(Templates[type]);

  if(Templates[type].icon){
    const popup_content_icon = document.createElement('div');
    popup_content_icon.classList.add('PopupContentIcon');
    popup_content_icon.innerHTML = Templates[type].icon;
    popup_content.append(popup_content_icon);
  }

  if(Templates[type].title){
    const popup_content_title = document.createElement('div');
    popup_content_title.classList.add('PopupContentTitle');
    popup_content_title.innerHTML = Templates[type].title;
    popup_content.append(popup_content_title);
  }

  if(Templates[type].description){
    const popup_content_description = document.createElement('div');
    popup_content_description.classList.add('PopupContentDescription');
    popup_content_description.innerHTML = Templates[type].description;
    popup_content.append(popup_content_description);
  }

  if(Templates[type].button){
    if( typeof Templates[type].button.link == 'function' ){
      var popup_content_button = document.createElement('button');
      popup_content_button.addEventListener('click', ()=> Templates[type].button.link())
    }else{
      var popup_content_button = document.createElement('a');
      popup_content_button.href = Templates[type].button.link;
    }
    
    popup_content_button.classList.add('PopupContentButton');
    popup_content_button.innerHTML = Templates[type].button.label;
    popup_content.append(popup_content_button);
  }

  popup.append(popup_content);

  document.body.append(popup);
    
    
  }else{
    console.log('popup type not found !');
  }

  }else{
    console.log('popup type required !');
  }
  
  
}

function qaFunc() {
  document.addEventListener('DOMContentLoaded', () => {
  if(!checkSelector('[state-container]')) return false
  const buttons = document.querySelectorAll('[state-container]');
    
  buttons.forEach(button => {
    let buview = button.querySelector('.openBy.view')
    let buhidden = button.querySelector('.openBy.hidden')
    button.addEventListener('click', () => {
      const answer = button.nextElementSibling;
      if(answer.style.height) {
        answer.style.height = null;
        button.classList.remove('open');
        buhidden.classList.remove('view')
        buhidden.classList.add('hidden')
        buview.classList.add('view')
      } else {
        answer.style.height = answer.scrollHeight + 'px';
        button.classList.add('open');
        buview.classList.add('hidden')
        buview.classList.remove('view')
        buhidden.classList.add('view')
      }
    });
  });
  });
} qaFunc()

function checkSelector(selector) {
  if(document.querySelector(selector)) {
    return 1
  } else {
    return 0
  }
}

function CollectionProduct(elem){
  const Selector = {
    slider: '[collection-product-slider]',
    characteristic: '[collection-product-characteristics]',
    show_characteristics: '[collection-product-btn-show-characteristics]',
    toggle_wishlist: '[collection-product-btn-toggle-wishlist]',
    quantity_input: '[collection-product-input-quantity]',
    quantity_length_input: '[collection-product-input-quantity-length]',
    quantity_length_button_plus: '[collection-product-btn-quantity-length-plus]',
    quantity_length_button_minus: '[collection-product-btn-quantity-length-minus]',
    add_to_cart_button: '[collection-product-btn-add-to-cart]',
    popup_get_share_button: '[collection-product-btn-popup-get-share]',
    popup_info_reserv_button: '[collection-product-btn-popup-info-reserv]'
  }
  const product = elem;
  const product_id = elem.dataset.productId;

  const slider = product.querySelector(Selector.slider);
  const slider_count_slides = slider.dataset.countSlides;

  const characteristic = product.querySelector(Selector.characteristic);
  const toggle_wishlist = product.querySelector(Selector.toggle_wishlist);

  
  const quantity_input = product.querySelector(Selector.quantity_input);
  const quantity_length_input = product.querySelector(Selector.quantity_length_input);
  const quantity_length_button_plus = product.querySelector(Selector.quantity_length_button_plus);
  const quantity_length_button_minus = product.querySelector(Selector.quantity_length_button_minus);

  const add_to_cart_button = product.querySelector(Selector.add_to_cart_button);
  const variant_id = add_to_cart_button.dataset.variantId;

  const popup_get_share_button = product.querySelector(Selector.popup_get_share_button);
  const popup_info_reserv_button = product.querySelector(Selector.popup_info_reserv_button);

  if(slider_count_slides > 1){
    const swiper = new Swiper(slider, {
      loop: true,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        type: "fraction",
      },
      navigation: {
        nextEl: slider.querySelector('[collection-product-slider-btn-next]'),
        prevEl: slider.querySelector('[collection-product-slider-btn-prev]'),
      }
    });
  }
  
  characteristic.style.height = characteristic.offsetHeight + 'px';
  characteristic.dataset.closedHeigh = characteristic.offsetHeight;
  characteristic.classList.add('close');

  if(Boolean(popup_get_share_button)){
    popup_get_share_button.addEventListener('click', ()=>{

      if(document.body.dataset.original_total_price < 30000){
        ProductPopup('getShareInfo');
      }else{
        popup_get_share_button.dataset.addedInCart = 'true'
        if(popup_get_share_button.dataset.sampleVariantId && popup_get_share_button.dataset.sampleInCart !== 'true'){
          
          AddToCart(popup_get_share_button.dataset.sampleVariantId, 1).then(()=>{
            popup_get_share_button.dataset.addedInCart = 'false';
             popup_get_share_button.dataset.sampleInCart='true'
          })
         
        }
        
      }
      
      
    })
  }
  
  if(Boolean(popup_info_reserv_button)){
    popup_info_reserv_button.addEventListener('click', ()=>{
      const title = popup_info_reserv_button.dataset.collectionTitle || 'Error Title';
      const description = popup_info_reserv_button.dataset.collectionDescription || 'Error Description';
      const button = popup_info_reserv_button.dataset.collectionButton || 'Continue';

      ProductPopup('reservInfo', { title, description, button });
    })
  }
  
  product.querySelector(Selector.show_characteristics).addEventListener('click', ()=>{
     if(characteristic.classList.contains('close')){
       characteristic.style.height = characteristic.scrollHeight + 'px';
       characteristic.classList.remove('close');
       characteristic.classList.add('open')
     }else{
       characteristic.style.height = characteristic.dataset.closedHeigh + 'px';
       characteristic.classList.remove('open');
       characteristic.classList.add('close')
     }
  })

  let wl = Wishlist({ product_id, toggle_wishlist });

  toggle_wishlist.addEventListener('click', () => {
  let index = wl.getIndex();

  if (index === -1) {
    wl.add(product_id);
    toggle_wishlist.classList.add('active');
  } else {
    wl.remove();
    toggle_wishlist.classList.remove('active');
  }
});

  quantity_length_button_plus.addEventListener('click', ()=>{
    if(Boolean(quantity_input)){
      const input_val = Number(quantity_input.value);
      const input_step = Number(quantity_input.step);
      const input_min = Number(quantity_input.min);
      const input_max = Number(quantity_input.max);
      const input_new_val = input_val + input_step;
     
      if(input_new_val <= input_max && input_new_val >= input_min){
         quantity_input.value = input_new_val;
      }
    }

    if(Boolean(quantity_length_input)){
      const input_val = Number(quantity_length_input.value);
      const input_step = Number(quantity_length_input.step);
      const input_min = Number(quantity_length_input.min);
      const input_max = Number(quantity_length_input.max);
      const input_new_val = input_val + input_step;
     
      if(input_new_val <= input_max && input_new_val >= input_min){
         quantity_length_input.value = roundToHalf(input_new_val)
      }
    }
    
  })

  quantity_length_button_minus.addEventListener('click', ()=>{
    if(Boolean(quantity_input)){
      const input_val = Number(quantity_input.value);
      const input_step =  Number(quantity_input.step);
      const input_min = Number(quantity_input.min);
      const input_max = Number(quantity_input.max);
      const input_new_val = input_val - input_step;
      if(input_new_val <= input_max && input_new_val >= input_min){
         quantity_input.value = input_new_val;
      }
    }

    if(Boolean(quantity_length_input)){
      const input_val = Number(quantity_length_input.value);
      const input_step =  Number(quantity_length_input.step);
      const input_min = Number(quantity_length_input.min);
      const input_max = Number(quantity_length_input.max);
      const input_new_val = input_val - input_step;
      if(input_new_val <= input_max && input_new_val >= input_min){
         quantity_length_input.value = roundToHalf(input_new_val)
      }
    }

    
    
  });

  if(Boolean(quantity_length_input)){
    quantity_length_input.addEventListener('change', ()=>{
      const input_val = Number(quantity_length_input.value);
      const input_step =  Number(quantity_length_input.step);
      const input_min = Number(quantity_length_input.min);
      const input_max = Number(quantity_length_input.max);
      
      quantity_length_input.value = roundToHalf(Number(quantity_length_input.value));

      if(Number(quantity_length_input.value) < input_min){
        quantity_length_input.value = roundToHalf(input_min)
      }

      if(Number(quantity_length_input.value) > input_max){
        quantity_length_input.value = roundToHalf(input_max)
      }
      
    })
  }

  // if(add_to_cart_button.dataset.incart == 'true'){
  //     add_to_cart_button.querySelector('.CollectionProductButtonAddtoCartLabel').innerHTML = 'Перейти в корзину';
  // }else{
  //   add_to_cart_button.querySelector('.CollectionProductButtonAddtoCartLabel').innerHTML = 'Добавить в корзину';
  // }

  add_to_cart_button.addEventListener('click', ()=>{
    if(add_to_cart_button.dataset.incart == 'true'){
      location.href='/cart';
    }else{
      add_to_cart_button.dataset.addedInCart = 'true'
      if(Boolean(quantity_input)){
        if(add_to_cart_button.dataset.available=="false"){
          properties = {
            '_type': 'Order'
          }
        AddToCart(variant_id, quantity_input.value, null , properties ).then(()=>{
          add_to_cart_button.dataset.addedInCart = 'false';
          add_to_cart_button.dataset.incart = 'true';
          
        });
      }else{
          AddToCart(variant_id, quantity_input.value ).then(()=>{
          add_to_cart_button.dataset.addedInCart = 'false';
          add_to_cart_button.dataset.incart = 'true';
          
        });
      }
      
      }
      if(Boolean(quantity_length_input)){
        if(add_to_cart_button.dataset.available=="false"){
          properties = {
            '_type': 'Order'
          }
          AddToCart(variant_id, 1, quantity_length_input.value, properties).then(()=>{
            add_to_cart_button.dataset.addedInCart = 'false';
            add_to_cart_button.dataset.incart = 'true';
          });
        }else{
          AddToCart(variant_id, 1, quantity_length_input.value).then(()=>{
            add_to_cart_button.dataset.addedInCart = 'false';
            add_to_cart_button.dataset.incart = 'true';
          });
        }
        
      }
      // getShopCart().then((new_cart)=>{
      //   UpdateAppCart(new_cart);
      // })
      
    }
    
  })

  document.addEventListener("UpdateCart", (event) => {
    let itemsbypid = event.detail.cart.items.filter((item)=>{
       return item.product_id == product_id;
     })

    const ProductInCartInfo = product.querySelector('.CollectionProductInCartInfo');
    const ProductInCartInfoLabel = product.querySelector('.CollectionProductInCartInfoLabel');
    
    if(itemsbypid.length > 0){
      add_to_cart_button.dataset.incart = 'true'; 
      product.dataset.inCart = 'true';
      //add_to_cart_button.querySelector('.CollectionProductButtonAddtoCartLabel').innerHTML = 'Перейти в корзину';
      ProductInCartInfoLabel.innerHTML = ProductInCartInfo.dataset.textIncart + ' (' + itemsbypid[0].presentment_price + ' ₪)';
    }else{
      add_to_cart_button.dataset.incart = 'false';
      product.dataset.inCart = 'false';
      //add_to_cart_button.querySelector('.CollectionProductButtonAddtoCartLabel').innerHTML = 'Добавить в корзину';
    }
  })
  
}

function roundToHalf(value) {
    return Math.round(value * 2) / 2;
}

function getAppCart(cartToken){
  let formData = {
    'shop': window.miracheltessutiapp.shop,
    'token': cartToken
    }
  
  return fetch(window.miracheltessutiapp.routes.root + 'api/get-cart', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json()).then((data)=>{
    document.dispatchEvent(new CustomEvent("UpdateAppCart", { detail: {cart: data}  } ));
    return data;
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};

async function getShopCart(){
  return fetch(window.Shopify.routes.root + 'cart.json', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then((data)=>{
    

    const product_id_null = data.items.filter((item)=>{
      return (item.product_id == null || !Boolean(item.product_id))
    })
    
    if(product_id_null.length > 0){
      return getShopCart();
    }else{
      return data;
    }
    
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}



document.addEventListener('DOMContentLoaded', () => {
  const checkSel = (selector) => !!document.querySelector(selector);
  const minus = document.querySelector('.buttonMinus')
  const plus = document.querySelector('.buttonPlus')

  if(checkSel('[collection-product-input-quantity-length]')) {
    const inputs = document.querySelectorAll('[collection-product-input-quantity-length]');
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.value.trim() === '' || input.value < input.min ) {
          const minValue = input.getAttribute('min') || 1;
          input.value = minValue;
        }
      });

      input.addEventListener('blur', () => {
        if (input.value.trim() === '' || input.value < input.min) {
          const minValue = input.getAttribute('min') || 1;
          input.value = minValue;
        }
      });
    });
  }

});

document.addEventListener('DOMContentLoaded', () => {
  const toggleMenu = document.querySelector('.toggle-menu');
  const toggleSortName = document.querySelector('[filter-sort-name]')
  const modal = document.querySelector('.modal');
  const sortItems = document.querySelectorAll('.modal [data-sort]');
  const productContainer = document.querySelector('#product-list');
  const products = document.querySelectorAll('.CollectionProduct'); 

  const sortProducts = (criteria) => {
    const sortedProducts = Array.from(products).sort((a, b) => {
      const priceA = parseFloat(
        a.querySelector('.CollectionProductInfoPrice').textContent.replace(/[^\d.]/g, '') || 0
      );
      const priceB = parseFloat(
        b.querySelector('.CollectionProductInfoPrice').textContent.replace(/[^\d.]/g, '') || 0
      );

      const dateA = new Date(a.getAttribute('data-date')) || new Date();
      const dateB = new Date(b.getAttribute('data-date')) || new Date();

      const saleA = a.getAttribute('data-discount')
      const saleB = b.getAttribute('data-discount')

      if (criteria === 'price-asc') return priceA - priceB;
      if (criteria === 'price-desc') return priceB - priceA;
      if (criteria === 'newest') return dateB - dateA;
      if (criteria === 'sale') return saleB - saleA;

      return 0;
    });

    productContainer.innerHTML = '';
    sortedProducts.forEach(product => productContainer.appendChild(product));
  };

  if(Boolean(toggleMenu)){
    toggleMenu.addEventListener('click', () => {
      modal.style.display = modal.style.display === 'none' || modal.style.display === '' ? 'block' : 'none';
    });
  }
  

  sortItems.forEach(item => {
    item.addEventListener('click', (e) => {
      const criteria = e.target.dataset.sort;
      const text = e.target.outerText
      modal.style.display = 'none';
      sortProducts(criteria);
      toggleSortName.innerText = text
    });
  });

  document.addEventListener('click', (e) => {
    if(Boolean(modal)){
      if (!modal.contains(e.target) && !toggleMenu.contains(e.target)) {
        modal.style.display = 'none';
      }
    }
  });
});


async function updateCartByReserv(cart_token){

  const shop_cart = await getShopCart();
  const app_cart = await getAppCart(cart_token);

  const shop_cart_items = shop_cart.items;
  const app_cart_items = app_cart.items;

  let updates = {  };
  let updates_length = 0;
  
  for(var shop_cart_item of shop_cart_items){
    const status = app_cart_items.filter((app_cart_item)=>{
      if((app_cart_item.key == shop_cart_item.key) && app_cart_item.expire_time =='not_expire_time'){
        return true;
      }
      return ( (app_cart_item.key == shop_cart_item.key) && (Date.parse(app_cart_item.expire_time) > Date.parse(app_cart.server_time)) ) 
    });

   
    
   if(!Boolean(status) || status.length == 0){
     updates[shop_cart_item.variant_id] = 0
     updates_length = updates_length + 1;
   }
    
  };

  if(updates_length > 0){

    AppdateCart(updates)
  
  // return fetch(window.Shopify.routes.root + 'cart/update.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify({updates})
  //   })
  //   .then(response => response.json())
  //   .catch((error) => {
  //     console.error('Error:', error);
  // });

  }else{
    return shop_cart;
  }

  
  
}

async function Cart(){

  const Selector = {
    cart_count: '[cart-count]',
  }

  const cart_counts = document.querySelectorAll(Selector.cart_count);
  
  let cart = await getShopCart();
  let cart_token = cart.token.split("?");

  updateCartByReserv(cart_token[0]).then( async (new_cart)=>{
    let cart = await getShopCart();
    let cart_token = cart.token.split("?");
    document.dispatchEvent(new CustomEvent("UpdateCart", { detail: {cart: new_cart}  } ));
  })
 
  
  // setInterval( async ()=>{
  //   const new_cart = await updateCartByReserv(cart_token[0]);
  //   document.dispatchEvent(new CustomEvent("UpdateCart", { detail: {cart: new_cart}  } ));
  // }, 20000);

  document.addEventListener("AddToCart", async function(event){
    
    setTimeout( async ()=>{
      let cart = await getShopCart();
      let cart_token = cart.token.split("?");
      updateCartByReserv(cart_token[0]).then((new_cart)=>{
        document.dispatchEvent(new CustomEvent("UpdateCart", { detail: {cart: new_cart}  } ));
      })
    },100)
  })

  document.addEventListener("UpdateCart", (event) => {
    if(Boolean(event.detail.cart)){
      if(Boolean(event.detail.cart.original_total_price)){
        document.body.dataset.original_total_price = event.detail.cart.original_total_price;
      }
    }
    
    
    [...cart_counts].map((cart_count)=>{
      if(Boolean(event.detail.cart?.item_count)){
        cart_count.innerHTML = event.detail.cart.item_count;
        if(event.detail.cart.item_count > 0){
          cart_count.dataset.show = 'true'
        }else{
          cart_count.dataset.show = 'false'
        }
      }
      
    })
    
  })

  return true;
}



document.addEventListener('DOMContentLoaded', function() {
    MenuInit()
    window.miracheltessutiapp = {
      routes:{
        root: "https://app.miracheltessuti.co.il/"
      },
      shop: window.Shopify.shop,
      customer:{
        id: getCustomerId
      }
    }

    document.querySelectorAll('[collection-product]').forEach((elem)=>CollectionProduct(elem));
  
    Cart();
   
}, false);

document.addEventListener('change_wishlist', (data) => {
  
  let countSelector = document.querySelector('#count-fav')
  let count = data.detail?.count

  if(data.detail?.type == 'add') {
    if(countSelector.outerText < 1) {
      countSelector.dataset.show = true
    }
  }
  if(data.detail?.type == 'remove') {
    
    if(count < 1) {
      countSelector.dataset.show = false
    }
  }
  countSelector.innerText = count
})

document.addEventListener('DOMContentLoaded', () => {
  const cartTimerId = 'cart-timer';
  const timerBlockId = 'cart-timer-block';
  const timerDuration = 60 * 60 * 1000;

  const cartContainer = document.querySelector('.cart__items');
  if (!cartContainer) return;

  const timerBlock = document.createElement('div');
  timerBlock.id = timerBlockId;
  timerBlock.style.padding = '10px'
  timerBlock.style.marginTop = '20px';
  timerBlock.style.textAlign = 'center';
  timerBlock.style.fontWeight = 'bold';
  cartContainer.appendChild(timerBlock);

  const saveTimerState = (endTime) => {
    localStorage.setItem(cartTimerId, endTime.toString());
  };

  const getTimerState = () => {
    const storedEndTime = localStorage.getItem(cartTimerId);
    return storedEndTime ? parseInt(storedEndTime, 10) : null;
  };

  const updateTimerUI = (timeLeft) => {
    if (timeLeft > 0) {
      const minutes = Math.floor(timeLeft / 60000);
      const seconds = Math.floor((timeLeft % 60000) / 1000);
      timerBlock.textContent = `Ваши товары зарезервированы: ${minutes} мин ${seconds} сек`;
    } else {
      timerBlock.textContent = 'Время истекло! Обновите корзину.';
      localStorage.removeItem(cartTimerId);
    }
  };

  const startTimer = (endTime) => {
    const interval = setInterval(() => {
      const now = Date.now();
      const timeLeft = endTime - now;
      if (timeLeft <= 0) {
        clearInterval(interval);
        updateTimerUI(0);
      } else {
        updateTimerUI(timeLeft);
      }
    }, 1000);
  };

  const initTimer = () => {
    const storedEndTime = getTimerState();
    const now = Date.now();

    if (storedEndTime && storedEndTime > now) {
      startTimer(storedEndTime);
    } else {
      const endTime = now + timerDuration;
      saveTimerState(endTime);
      startTimer(endTime);
    }
  };

  initTimer();
});
